import { GiveAwardContent } from './GiveAwardContent';
import { SelectAwardContent } from './SelectAwardContent';
import { Stage, useAwardModalState } from './state';

const contentFor = (stage: Stage) =>
	({
		[Stage.Select]: <SelectAwardContent />,
		[Stage.Give]: <GiveAwardContent />,
	})[stage];

export const AwardModalContent = () => {
	const { stage } = useAwardModalState();

	return <>{contentFor(stage)}</>;
};
